import { State } from '../state';

export const UsermanagementSelectors = {
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    usermanagement: (state: State) => state.Usermanagement,
};
